<template>
  <footer>
    <p class="lb2 g400">주식회사 운세당 대표 임수연</p>
    <p class="lb2 g400">사업자등록번호 741-81-03882</p>
    <p class="lb2 g400">통신판매업신고번호 제 2026-서울마포-0912 호</p>
    <p class="lb2 g400">주소 서울특별시 마포구 월드컵북로 98, 2층 202-576호(성산동)</p>
    <p class="lb2 g400">고객문의 unsedang777@gmail.com</p>
    <p class="lb2 g400">대표전화 070-4466-8979</p>
  </footer>
</template>
